import React from 'react'
import DotIndicator from './DotIndicator'
import { dashboard_popup_teacher_profile_details_icon } from '../../../../../assets/images/images'

const UserAccountDetails = ({ fields = [], step = 5, title = "Your Account Details", id = "5" }) => {
    const banks = [{ label: "BOI", value: 1 }, { label: "ICICI", value: 2 }]
    return (
        <div
            key={id}
            className="dashboard-popup-teacher-profile-details-folder"
        >
            <div className="dashboard-popup-teacher-profile-details-title">
                <div className="dashboard-popup-teacher-profile-details-image">
                    <img
                        src={dashboard_popup_teacher_profile_details_icon}
                        alt=""
                    />
                </div>
                <h2>{title}</h2>
            </div>
            <div className="dashboard-popup-teacher-profile-details-form">
                <div className="dashboard-popup-teacher-profile-details-form-container">
                    <div className="dashboard-popup-teacher-profile-details-input">
                        <label>Account Holder Name</label>
                        <input
                            id="teacher-create-profile-input"
                            type="name"
                            name="name"
                        // style={
                        //   formErrors.name
                        //     ? { border: "1px solid red" }
                        //     : null
                        // }
                        // value={formState.name || ""}
                        // placeholder="Full name"
                        // onChange={handleInputChange}
                        />
                        {/* <p>
                                            {formErrors.name}
                                            {formErrors.title}
                                          </p> */}
                    </div>
                    <div className="dashboard-popup-teacher-profile-details-input">
                        <label>Bank</label>
                        <div className="dashboard-popup-teacher-profile-gender-folder">
                            <select
                                id="gendar-select-feild"
                                name="gender"
                            //   style={
                            //     formErrors.gender
                            //       ? { border: "1px solid red" }
                            //       : null
                            //   }
                            //   value={formState.gender || ""}
                            //   onChange={handleInputChange}
                            >
                                {banks.map((bank) => {
                                    return (
                                        <option
                                            key={bank.value}
                                            value={bank.value}
                                        >
                                            {bank.name}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                        {/* <p>{formErrors.gender}</p> */}
                    </div>
                    <div className="dashboard-popup-teacher-profile-details-input">
                        <label>Account Number</label>
                        <input
                            type="text"
                            placeholder="Account Number"
                            name="account"
                        // style={
                        //     formErrors.email
                        //         ? { border: "1px solid red" }
                        //         : null
                        // }
                        // value={formState.email || ""}
                        // onChange={handleInputChange}
                        />
                        {/* <div className="form-icon">
                            <img src={email_image} alt="" />
                        </div> */}
                        {/* <p>{formErrors.email}</p> */}
                    </div>
                    <div className="dashboard-popup-teacher-profile-details-input">
                        <label>IFSC Code</label>
                        <input
                            type="text"
                            placeholder="Account Number"
                            name="account"
                        // style={
                        //     formErrors.email
                        //         ? { border: "1px solid red" }
                        //         : null
                        // }
                        // value={formState.email || ""}
                        // onChange={handleInputChange}
                        />
                        {/* <div className="form-icon">
                            <img src={gender_image} alt="" />
                        </div> */}
                        {/* <p>{formErrors.gender}</p> */}
                    </div>

                    <div className="dashboard-popup-teacher-profile-details-input">
                        <label>Bank</label>
                        <div className="dashboard-popup-teacher-profile-gender-folder">
                            <select
                                id="gendar-select-feild"
                                name="gender"
                            //   style={
                            //     formErrors.gender
                            //       ? { border: "1px solid red" }
                            //       : null
                            //   }
                            //   value={formState.gender || ""}
                            //   onChange={handleInputChange}
                            >
                                {banks.map((bank) => {
                                    return (
                                        <option
                                            key={bank.value}
                                            value={bank.value}
                                        >
                                            {bank.name}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                        {/* <p>{formErrors.gender}</p> */}
                    </div>
                </div>
            <DotIndicator fields={fields} step={step} />
            </div>
        </div>
    )
}

export default UserAccountDetails